export const BASE_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000'
export const API_KEY = import.meta.env.VITE_API_KEY_IOS || ''
export const CHANNEL_TYPE =
  import.meta.env.VITE_CHANNEL_TYPE || 'external_dashboard'

export const DEBUG_MODE = import.meta.env.VITE_DEBUG_MODE === 'true'
